import { render, staticRenderFns } from "./layoutOrganization.vue?vue&type=template&id=51b23ecc&"
import script from "./layoutOrganization.vue?vue&type=script&lang=js&"
export * from "./layoutOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports